export default __webpack_public_path__ + "img/7fdfd820494f43e8226c706e727a4418.png";